import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

function Navigation() {
  return (
    <nav className="main-nav">
      <Link to="/" className="nav-link">Home</Link>
      <Link to="/about" className="nav-link">About</Link>
      <Link to="/protocol/v0.2" className="nav-link">Protocol</Link>
    </nav>
  );
}

function About() {
  useEffect(() => {
    document.title = "About wCross";
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <Navigation />
        <h1>About wCross</h1>
        <div className="about-content">
          <p className="tagline">
            Want to use your Bitcoin or Ethereum on other blockchains? Meet wCross!
          </p>
          
          <p className="description">
            We use "Wrapped Native Coin" technology to safely transform your assets, like ETH, 
            into mapped tokens such as "wETH (wCross Ethereum)."
          </p>

          <p className="description">
            The best part? Every wETH is 1:1 pegged to a real ETH, guaranteeing its value 
            and allowing you to swap it back anytime.
          </p>

          <p className="tagline">
            wCross: Securely and easily move your digital assets across chains, hassle-free!
          </p>

          <div className="features">
            <h2>In simple terms:</h2>
            
            <div className="feature-item">
              <h3>Your Coins, Across Chains</h3>
              <p>Take coins from one blockchain (like ETH from Ethereum) and use them on another (like the XRP Ledger).</p>
            </div>

            <div className="feature-item">
              <h3>Securely Wrapped, 1:1 Pegged</h3>
              <p>Your original coins are safely locked on their native chain, and an equal amount of "wrapped coins" (like wETH) is issued on the target chain, always holding the same value.</p>
            </div>

            <div className="feature-item">
              <h3>Swap Back Anytime</h3>
              <p>You can always exchange your "wrapped coins" on the target chain back to the real, native coins on their original chain.</p>
            </div>
          </div>

          <p className="conclusion">
            wCross is building a secure, transparent, and efficient bridge for your assets.
          </p>
        </div>
      </header>
    </div>
  );
}

export default About; 